import { env } from "@/config/envvars";

export function getMcpServerUrl() {
  return `${env.BACKEND_URL.replace(/\/$/, "")}/mcp`;
}

export function getMcpClientConfigSnippet() {
  const url = getMcpServerUrl();

  return `"creative-os": {
  "url": "${url}",
  "headers": {
    "Authorization": "Bearer API_KEY"
  }
}`;
}

export const CLAUDE_CONNECTOR_STEPS = [
  "Open claude.ai/customize/connectors. The add connector modal opens.",
  "Call it Creo and paste the MCP URL above.",
  "Click Continue.",
] as const;

export const CURSOR_MCP_STEPS = [
  "Create an API key in Settings → API keys.",
  "Add the CreativeOS MCP server to your client config with that key as the Bearer token.",
] as const;
